export default "__VITE_ASSET__CnM5gob7__"